<template>
    <div class="container-fluid">
        <div v-if="$can('serviceorder create')" class="row justify-content-center h-100">
            <div class="default-page-width h-100">
                <div class="card card-default h-100">
                    <div class="card-header">{{$t('service.'+mode+'.title')}}</div>
                    <div class="card-body">
                        <div class="h-100">
                            <form-service
                                :mode="'edit'"
                                :context="context"
                                :orderid=orderid
                                :formdisabled="formdisabled"
                            ></form-service>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('serviceorder create')">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>

import FormService from "./form-service.vue";

export default {
    name: "service-order-edit",
    components: {FormService},
    props: {
        user: [String, Number],
        mode: {
            type: String,
            default: 'edit'
        },
        formdisabled: Boolean,
        context:[String],
        orderid:[Number]
    },
    data: function () {
        return {
            presetRmsObjectId: undefined
        }
    },
    mounted() {
        console.log("service-order-edit init... ", this.orderid, this.mode, this.context);
    },

}
</script>

<style scoped>

</style>
